import { ErrorResponse } from '../../../../types/API';
import { FlowsAPIAnswerError, FlowsAPIAnswerSuccess } from './ApiTypes';

export const isValidFlowsResponse = (
  flowsResponse: FlowsAPIAnswerSuccess | FlowsAPIAnswerError,
): flowsResponse is FlowsAPIAnswerSuccess =>
  !['ERROR'].includes(flowsResponse.status);

export const isAPIErrorResponse = (
  flowsResponse: FlowsAPIAnswerError | ErrorResponse,
): flowsResponse is ErrorResponse => !!(flowsResponse as ErrorResponse).detail;
